<template>
  <div class="company-information page-content">
    <section class="module__header">
      <h2 class="module__header__title">公司概况</h2>
      <p class="module__header__subtitle">Company Overview</p>
    </section>
    <section class="content">
      <section class="left">
        <section class="basic card">
          <p class="title">基本信息</p>
          <ul>
            <li v-for="item in basic" :key="item.key">
              <span class="label">{{ item.label }}</span>
              <span class="value">{{ pageData[item.key] || "-" }}</span>
            </li>
          </ul>
        </section>
        <section class="contact card">
          <p class="title">联系方式</p>
          <ul>
            <li v-for="item in contact" :key="item.key">
              <span class="label">{{ item.label }}</span>
              <span class="value">{{ pageData[item.key] || "-" }}</span>
            </li>
          </ul>
        </section>
      </section>
      <section class="business card">
        <p class="title">业务信息</p>
        <ul>
          <li v-for="item in business" :key="item.key">
            <span class="label">{{ item.label }}</span>
            <span class="value">{{ pageData[item.key] || "-" }}</span>
          </li>
        </ul>
      </section>
    </section>
  </div>
</template>

<script>
import GlobalStore from "@/store/global";
import { isObject } from "lodash";
export default {
  name: "company-information",
  data() {
    return {
      basic: [
        { label: "公司名称", key: "companyName" },
        { label: "注册资本", key: "registeredCapital" },
        { label: "成立时间", key: "establishmentTime" },
        { label: "公司地址", key: "companyAddress" },
      ],
      contact: [
        { label: "网站名称", key: "websiteName" },
        { label: "客服电话", key: "customerServicePhone" },
        { label: "投诉电话", key: "complaintPhone" },
      ],
      business: [
        { label: "业务范围", key: "businessScope" },
        { label: "经营区域", key: "businessArea" },
        { label: "分支机构", key: "branch" },
      ],
      companyProfile: {},
    };
  },
  computed: {
    pageData() {
      const commonInfo = isObject(GlobalStore.commonInfo)
        ? GlobalStore.commonInfo
        : null;

      return {
        ...commonInfo,
        ...this.companyProfile,
      };
    },
  },
  created() {
    this.getCompanyProfile();
  },
  methods: {
    getCompanyProfile() {
      this.$get("/base/official-site/anonymous/company-profile")
        .then((res) => {
          if (res.data) {
            this.companyProfile = res.data;
          }
        })
        .catch((error) => {});
    },
  },
};
</script>

<style lang="less">
.company-information {
  & > .content {
    display: flex;
    align-items: top;
    justify-content: space-between;
    .card {
      background: #ffffff;
      box-shadow: 0 10px 10px 0 rgba(135, 164, 208, 0.06);
      padding: 24px;
      box-sizing: border-box;
      .title {
        font-family: PingFangSC-Medium;
        font-size: 22px;
        line-height: 30px;
        color: #0044c1;
        letter-spacing: 0;
        font-weight: bold;
        padding-bottom: 50px;
      }
      ul {
        li {
          list-style: none;
          z-index: 1;
          display: flex;
          align-items: top;
          box-sizing: border-box;
          .label {
            font-family: PingFangSC-Medium;
            font-size: 18px;
            color: #121519;
            letter-spacing: 0;
            line-height: 26px;
            padding-right: 16px;
            flex-shrink: 0;
            position: relative;
            padding-left: 20px;
            &::before {
              content: "";
              width: 17px;
              height: 16px;
              background: url(https://static.soyoung.com/sy-pre/list-style-1682493000746.png)
                center center no-repeat;
              background-size: 100% 100%;
              position: absolute;
              left: 0;
              top: 5px;
            }
          }
          .value {
            font-family: PingFangSC-Regular;
            font-size: 18px;
            color: #53595f;
            letter-spacing: 0;
            text-align: justify;
            line-height: 26px;
            flex: auto;
            word-break: break-all;
          }
        }
        li + li {
          margin-top: 23px;
        }
      }
    }
    .left {
      width: 525px;
      display: flex;
      flex-direction: column;
      flex-shrink: 0;
      // justify-content: space-between;
      .card {
        flex: auto;
      }
      .card + .card {
        margin-top: 22px;
      }
    }
    .business {
      flex: auto;
      margin-left: 22px;
      min-height: 593px;
    }
  }
}
@media all and (max-width: 1200px) {
  .company-information {
    & > .content {
      flex-wrap: wrap;
      padding: 0 15px;
      box-sizing: border-box;
      .left,
      .business {
        width: 100%;
      }
      .business {
        margin-left: 0;
        margin-top: 23px;
      }
    }
  }
}
</style>
